import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { Utente } from "../interfaces/user";
import { AnagraficaEnte } from "../interfaces/anagrafica-ente.interface";

@Injectable({ providedIn: 'root' })
export class AppService {
  constructor(
    private http: HttpClient
  ) { }
  private _user: Utente = {};
  private _ente: AnagraficaEnte = {};
  get user() {
    return this._user;
  }
  set user(user: Utente) {
    this._user = user;
  }
  get ente() {
    return this._ente;
  }
  set ente(ente: AnagraficaEnte) {
    this._ente = ente;
  }

  get(): Observable<any> {
    return this.http.get('api/utente');
  }
}
